<script>
export default {
  props: {
    pointers: Array,
  },
  computed: {
    subdomain() {
      return this.cname.value.split('.').slice(0, -2).join('.')
    },
    domain() {
      return this.cname.value.split('.').slice(-2).join('.')
    },
    cname() {
      return this.pointers.find(({ type }) => type === 'CNAME')
    },
    a() {
      return this.pointers.find(({ type }) => type === 'A')
    },
  },
}
</script>

<template>
  <ol>
    <li>
      Gå til <a href="https://domene.shop/login">Domeneshop</a> sitt nettsted og logg inn med brukernavn og passord.
    </li>
    <li>
      Naviger til "Mine domener" og klikk på <b>{{ domain }}</b>
    </li>
    <li>
      Gå til "DNS-pekere" og trykk på "Vis avanserte innstillinger (SRV, TXT, TTL, etc.)" dersom det er tilgjengelig.
    </li>
    <li>
      Legg til en CNAME-post for <b>{{ subdomain }}</b
      >:
    </li>
    <ul>
      <li>Naviger til nederste rad for å legge til en ny peker</li>
      <li>
        I feltet for "Vertsnavn", skriv inn <b>{{ subdomain }}</b>
      </li>
      <li>I feltet for "TTL", velg <b>1 time</b></li>
      <li>I feltet for "RR-type", velg <b>CNAME</b></li>
      <li>
        I feltet for "Data", skriv inn <b>{{ cname.target }}</b>
      </li>
      <li>Lagre endringene ved å klikke det grønne plus ikonet til høyre.</li>
    </ul>
    <template v-if="a">
      <li>Legg til en <b>A</b>-post for {{ domain }}:</li>
      <ul>
        <li>Naviger til nederste rad for å legge til en ny peker</li>
        <li>I feltet for "Vertsnavn", la det stå tomt</li>
        <li>I feltet for "TTL", velg <b>1 time</b></li>
        <li>I feltet for "RR-type", velg <b>A</b></li>
        <li>
          I feltet for "Data", skriv inn <b>{{ a.target }}</b>
        </li>
        <li>Lagre endringene ved å klikke det grønne plus ikonet til høyre.</li>
      </ul>
    </template>
    <li>Dersom du har en annen CNAME peker som benytter "Vertsnavn" <b>{{ subdomain }}</b> (se pkt. 4), må denne slettes slik at domenet fungerer riktig</li>
    <template v-if="a">
      <li>Dersom du har en annen A peker med "Vertsnavn" som er tom (se pkt. 5), må denne slettes slik at domenet fungerer riktig</li>
    </template>
  </ol>
</template>
